import { Injectable } from '@angular/core';

import {environment} from "@src/environments/environment";
import {BaseService} from "@shared/services/base.service";

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService extends BaseService {

  constructor() {
    super();
  }

  protected getUrl(urlEnding: string): string {
    return environment.hammerApiUrl + urlEnding;
  }

  protected getAuthUrl(urlEnding: string): string {
    return environment.nostromoAuthApiUrl + urlEnding;
  }

  protected getNewApiUrl(urlEnding: string): string {
    return environment.genesisApiUrl + urlEnding;
  }
}
